import { Tooltip, Typography } from "antd";
import { useTranslation } from "react-i18next";
import { BUILD_INFO } from "../build-info";
import { fmtTime } from "../shared-core";
import type { SystemVersion as SystemVersionInfo } from "../../shared/system-version";

export function SystemVersion({ info = BUILD_INFO }: { info?: SystemVersionInfo } = {}) {
  const { t } = useTranslation();
  const title = [
    info.revision ? t("common.buildRevision", { revision: info.revision.slice(0, 7) }) : null,
    info.builtAt ? t("common.buildTime", { time: fmtTime(info.builtAt) }) : null,
    info.sourceDigest ? t("common.buildFingerprint", { digest: info.sourceDigest.slice(0, 8) }) : null,
    info.development ? t("common.developmentBuild") : null,
  ].filter(Boolean).join(" · ");
  return (
    <Tooltip title={title || undefined}>
      <Typography.Text type="secondary" className="system-version" tabIndex={0}>
        {t("common.releaseVersion", { version: info.version })}
      </Typography.Text>
    </Tooltip>
  );
}
